import { ThemePicker } from '../components/Theme'
import { useState } from 'react'
import { api, ApiError } from '../api/client'
import type { User } from '../api/types'

export function Login({ onSignedIn }: { onSignedIn: (u: User) => void }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      onSignedIn(await api.login(email, password))
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 0
          ? 'Couldn’t reach the CRM. Please try again in a moment.'
          : err instanceof Error
            ? err.message
            : 'Sign-in failed',
      )
      setBusy(false)
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-theme-picker"><ThemePicker /></div>
      <aside className="login-story">
        <div className="login-brand"><span className="brand-monogram">b<span>.</span></span> buckingham.</div>
        <div className="login-story-body"><div className="eyebrow">BUCKINGHAM MORTGAGE</div><h2>Mortgage<br /><em>intelligence.</em></h2><p>Pipeline from LendingPad, leads from the campaigns, and one record for each person across them.</p>
          <div className="relationship-art" aria-hidden="true"><div className="art-orbit orbit-one" /><div className="art-orbit orbit-two" /><div className="art-core">b.</div><span className="art-label art-label-one">A stronger pipeline</span><span className="art-label art-label-two">A personal connection</span><span className="art-node node-one" /><span className="art-node node-two" /></div>
        </div><div className="login-story-foot">BUCKINGHAM MORTGAGE <span>People first. Always.</span></div>
      </aside>
      <div className="login-form-panel"><div className="card login-card">
        <div className="eyebrow">YOUR WORKSPACE AWAITS</div><h1>Welcome back.</h1>
        <p className="sub">Your people. Your pipeline. Your next chapter.</p>

        {error ? <div className="login-err">{error}</div> : null}

        <form onSubmit={submit}>
          <label className="label">
            <span>Email</span>
            <input
              className="field"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@bfgusa.com"
              required
              autoFocus
            />
          </label>
          <label className="label">
            <span>Password</span>
            <input
              className="field"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <button className="btn primary" style={{ width: '100%', justifyContent: 'center' }} disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in to your workspace →'}
          </button>
        </form>
      <p className="login-help">Use your Buckingham account to continue.</p></div></div>
    </div>
  )
}
